import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { MenuService } from '../../_service/menu/menu.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SettingsService } from 'app/user-center/settings/settings.service';
@Component({
  selector: 'app-dn-menu',
  templateUrl: './dn-menu.component.html',
  styleUrls: ['./dn-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DnMenuComponent implements OnInit, OnDestroy {
  @Input() navType = '';
  ngOnDestroy(): void {
    this.subscriptions.forEach(p => {
      if (p != null) {
        if (typeof p == 'function') {
          p();
        }
        else if (!!p['unsubscript']) {
          p['unsubscript']();
        }
      }

    });
  }
  expanded = false;
  expandedSubmenu;
  mouseLeaveDelay = false;
  menuUnsubscribe;
  menu: Array<any> = [];
  navTitle = this.navType === 'discovery' ? '发现' : '影视';
 // isApp = environment.app;
 // isAdult = environment.cinema == 2;
  isInDiscovery = false;
  isNSFWMode = true;
  ogMenu = [];
  constructor(
    private _menuService: MenuService,
    private _router: Router,
    private _cd: ChangeDetectorRef,
    private _route: ActivatedRoute,
    //  @Inject(AppStore) private store: Store<VideoState>,
    private settingsService: SettingsService,
  ) {

  }

  readState() {
    // const allState = this.store.getState();
    // const videoState: VideoState = allState['video'] as VideoState;
    // const baseUrl = this._router.url.split('?')[0].substr(1).split('/')[0];
    // if (videoState.currentVideo && baseUrl === 'video') {
    //   this.navTitle = videoState.currentVideo.genre;
    // }
  }
  subscriptions: Array<any> = [];

  ngOnInit() {
    //this.menu = this._menuService.getMainMenu();

    // this.subscriptions.push(this.store.subscribe(() => this.readState()));
    // this.readState();

    this.subscriptions.push(
      this.navType === 'discovery' ? this._menuService.getDiscoveryMenu().subscribe(res => {
        this.menu = res;
        this.routeChange();
      }) : this._menuService.getMainMenu().subscribe(res => {
        this.menu = res;
        this.ogMenu = res; // 缓存完整的menu
        this.filterNSFW(this.ogMenu);
        this.routeChange();
      }),

      this._router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          this.routeChange();
        }
      }),

      this.settingsService.settings$.subscribe(settings => {
        if ('isNSFWMode' in settings) {
          this.isNSFWMode = settings.isNSFWMode;
        }
        if (this.navType !== 'discovery') {
          this.filterNSFW(this.ogMenu);
        }
      })

    );

    // this._route.queryParams.subscribe((queryParams: any) => {
    //   this.detectMenu(queryParams.cid,queryParams.tag)
    // });
  }

  filterNSFW(menu) {
    if (menu.length === 0) {
      return;
    }
    if (!this.isNSFWMode) {
      this.menu = menu.filter(r => r.title !== '午夜版');
    } else {
      this.menu = menu;
    }
  }

  private getRoute(): string[] {
    return this._router.url.split('?')[0].split('/').filter(p => p);
  }

  private routeChange() {
    this.hideMenu(true);
    this.menu.filter(p => p.isActive).forEach(p => {
      p.isActive = false,
        p.submenu.forEach(m => m.isActive = false)
    });
    const baseUrl = this.getRoute();
    if (this.navType === 'discovery') {
      // 发现导航
      const label = this._route.snapshot.queryParams["label"];
      const tag = this._route.snapshot.queryParams["tag"];
      if (baseUrl[0] !== 'discovery') {
        this.navTitle = '发现';
        this.isInDiscovery = false;
      } else {
        this.isInDiscovery = true;
        if (!!label) {
          this.navTitle = this.segmentToNavTitle(tag, label);
        } else if (!!tag) {
          this.navTitle = this.segmentToNavTitle(tag);
        } else {
          this.navTitle = '发现';
        }
      }
      return;
    };
    if (baseUrl.length == 0 || (baseUrl[0] == "list" && baseUrl.length == 1)) {
      this.navTitle = '影视';
    }
    else {
      switch (baseUrl[0]) {
        case "list":
          this.navTitle = this.segmentToNavTitle(baseUrl[1].split('-')[0]);
          break;
        default:
          this.navTitle = this.segmentToNavTitle(baseUrl[0]);
          break;
      }
    }

    this._cd.detectChanges();
    // switch(baseUrl[0])
    // {
    //   case "list":
    //     break;
    // }
    // if (baseUrl[0] === 'list') {
    // } else if (baseUrl[0] === '') {
    //   this.navTitle = '影视';
    // } else if (baseUrl[0] === 'short-videos') {
    //   const cid = this._route.snapshot.queryParams['cid'];
    //   const menuItem = this._menuService.getMenuItemByCid(cid);
    //   if (menuItem) {
    //     this.navTitle = menuItem.title;
    //   }
    // } else {
    //   this.navTitle = this.segmentToNavTitle(baseUrl[0]);
    // }
  }
  // private detectMenu(cid, tag) {
  //   const baseUrl = this.getRoute();
  //   if (baseUrl[0] === 'list') {
  //     if (tag && tag !== '-1') {
  //       this.navTitle = tag;
  //       return;
  //     }

  //     const menuItem = this._menuService.getMenuItemByCid(cid);

  //     if (menuItem && cid) {
  //       if (menuItem.params && menuItem.params.cid === cid) {
  //         this.navTitle = menuItem.title;
  //       } else {
  //         if (!tag && menuItem.routerLink !== '/list') {
  //           this.navTitle = menuItem.title;
  //           return;
  //         }
  //         const submenus = menuItem.submenu;
  //         if (submenus != null)
  //           this.navTitle = submenus.filter(item => item.params.cid === cid)[0].title;
  //       }
  //     } else {
  //       this.navTitle = '影视';
  //     }
  //   }
  // }

  //loaded = false;
  openMenu() {
    this.mouseLeaveDelay = false;
    this.expanded = true;
    //this.loaded = true;

  }
  hideTimeout = null;
  hideMenu(imediately = false) {
    this.mouseLeaveDelay = true;
    this.expandedSubmenu = undefined;
    clearTimeout(this.hideTimeout)
    this.hideTimeout = setTimeout(() => {
      if (this.mouseLeaveDelay) {
        this.expanded = false;
        this._cd.detectChanges();
      }
    }, imediately ? 0 : 200);
  }

  onMenuItemHover(itemId) {
    this.expandedSubmenu = itemId;
  }

  OnDestroy() {
    this.menuUnsubscribe();
  }
  defaultRoute = [{
    key: "user",
    title: "个人中心"
  },
  {
    key: "help",
    title: "帮助中心"
  },
  {
    title: "华人",
    key: "chinese",
    parentKey: "svideo"
  },
  {
    title: "游戏",
    key: "game",
    parentKey: "svideo"
  },
  {
    title: "新闻",
    key: "news",
    parentKey: "svideo"
  },
  {
    title: "华人",
    key: "chinese",
    parentKey: "svideo"
  },
  {
    title: "娱乐",
    key: "yule",
    parentKey: "svideo"
  },
  {
    title: "华人",
    key: "chinese",
    parentKey: "svideo"
  },
  {
    title: "生活",
    key: "life",
    parentKey: "svideo"
  },
  {
    title: "音乐",
    key: "music",
    parentKey: "svideo"
  },
  {
    title: "时尚",
    key: "fashion",
    parentKey: "svideo"
  },
  {
    title: "科技",
    key: "tech",
    parentKey: "svideo"
  },
  {
    title: "发现",
    key: "discovery",
  },
  {
    key: "tvlive",
    title: "电视直播"
  },
  ]
  segmentToNavTitle(s, label = null) {
    var anyData = !!this.menu ? this.menu.filter(p => p.slug == s) : [];
    //console.log(this.menu)
    if (!!s && anyData.length > 0) {
      anyData[0].isActive = true;
      if (!!label && anyData[0].submenu.length > 0) {
        anyData[0].submenu.filter(m => m.title === label)[0].isActive = true;
        return anyData[0].submenu.filter(m => m.title === label)[0].title;
      }
      return anyData[0].title;
    }
    else {
      let findKey = this.defaultRoute.filter(p => p.key == s);
      if (findKey.length > 0) {
        let key = "/" + (findKey[0].parentKey || findKey[0].key);
        if (!!findKey[0].parentKey) {
          this.menu.filter(p => p.routerLink == key).forEach(p => {
            p.isActive = true
            if (!!p.submenu && p.submenu.length > 0)
              p.submenu.filter(p => p.routerLink == "/" + findKey[0].key).forEach(d => d.isActive = true)
          });
        }
        else {
          this.menu.filter(p => p.routerLink == key).forEach(p => p.isActive = true);
        }
        return findKey[0].title;
      }
      return "影视";
      // switch (s) {
      //   case 'user': {
      //     this.menu.filter(p=>p.routerLink == '/user').forEach(p=>p.isActive = true);
      //     return '个人中心';
      //   }
      //   case 'help': {
      //     this.menu.filter(p=>p.routerLink == '/help').forEach(p=>p.isActive = true);
      //     return '帮助中心';
      //   }
      //   default:
      //     return '影视';
      // }
    }


  }

  toggleMenu() {
    this.expanded = !this.expanded;

  }
}
